module.exports = __webpack_public_path__ + "static/guides-5ef55a1349769120d441f266da26f73e.png";